import React, { PureComponent, PropTypes } from 'react';
import EventAccountData from './EventAccountData';
import CityProvincePostal from '../CityProvincePostal';
import { extractAddress, isAccountData } from '../../util/EventUtil';

export default class EventCityProvince extends PureComponent {
  static propTypes = {
    event: PropTypes.shape({
      eventType: PropTypes.string.isRequired
    })
  };

  static defaultProps = {};

  render() {
    const { className, event } = this.props;
    const { city, province } = extractAddress(event) || {};

    return (
      <EventAccountData className={className}highlighted={isAccountData(event, 'location')}>
        <CityProvincePostal city={city} province={province}/>
      </EventAccountData>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/event/EventCityProvince.jsx